<script setup>
import { computed } from 'vue';
import { useMessageContext } from '../../provider.js';

import MessageFormatter from 'shared/helpers/MessageFormatter.js';
import { MESSAGE_VARIANTS } from '../../constants';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
});

const { variant } = useMessageContext();

const formattedContent = computed(() => {
  if (variant.value === MESSAGE_VARIANTS.ACTIVITY) {
    return props.content;
  }

  return new MessageFormatter(props.content).formattedMessage;
});
</script>

<template>
  <span 
    v-dompurify-html="formattedContent" 
    class="prose prose-bubble message-text-content"
  />
</template>

<style scoped>
.message-text-content {
  unicode-bidi: plaintext;
  direction: auto;
}
</style>

<style>
.prose-bubble p,
.prose-bubble div,
.prose-bubble span {
  unicode-bidi: plaintext;
  direction: auto;
}
</style>
